/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ExecuteBcrMatchesReportMutationRequest, ExecuteBcrMatchesReportMutationResponse, ExecuteBcrMatchesReportQueryParams, ExecuteBcrMatchesReport400, ExecuteBcrMatchesReport500 } from "../models/ExecuteBcrMatchesReport";

export function getExecuteBcrMatchesReportUrl() {
  const res = { method: 'POST', url: `/reports/bcr-matches/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /reports/bcr-matches/results}
 */
export async function executeBcrMatchesReport(data: ExecuteBcrMatchesReportMutationRequest, params?: ExecuteBcrMatchesReportQueryParams, config: Partial<RequestConfig<ExecuteBcrMatchesReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ExecuteBcrMatchesReportMutationResponse, ResponseErrorConfig<ExecuteBcrMatchesReport400 | ExecuteBcrMatchesReport500>, ExecuteBcrMatchesReportMutationRequest>({ method : "POST", url : getExecuteBcrMatchesReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}